import { Modal, message, Select, Spin } from 'antd';
import React, { Component } from 'react'
import Fetch from '../../../../common/Fetch';
import API_URL from '../../../../common/url';

const Option = Select.Option;

class SigninContract extends Component {
    state = {
        visible: false,
        loading: false,
        params: {},
        paymentTermsList: [],
    }

    show = params => {
        this.setState({
            visible: true,
            loading: false,
            // 存副本，避免修改时污染父组件列表行数据
            params: { ...params },
        }, () => {
            this.queryPaymentTerms();
        });
    }

    queryPaymentTerms = () => {
        const { paymentTermsList } = this.state;
        // 账期配置基本不变，只请求一次，之后打开弹窗复用缓存做文案转ID
        if (paymentTermsList.length) {
            this.convertPaymentTermsText(paymentTermsList);
            return;
        }
        Fetch.post(API_URL.investigation.queryByParams, {
            typeName: 'CONTRACT_PAYMENT_TERM',
        }).then(res => {
            this.convertPaymentTermsText(res.typeConfigureList || []);
        });
    }

    // 行数据里存的是账期文案，回显时转换成对应的配置ID，避免不做改动直接保存时把文案当成ID传给后端
    convertPaymentTermsText = paymentTermsList => {
        this.setState(prev => {
            const matched = paymentTermsList.find(el => el.typeValue === prev.params.contractAgreedPaymentTerms);
            return {
                paymentTermsList,
                params: matched ? { ...prev.params, contractAgreedPaymentTerms: matched.typeConfigureId } : prev.params,
            };
        });
    }

    hide = () => {
        this.setState({
            visible: false,
            loading: false,
        });
    }

    submit = () => {
        const { loading, params, paymentTermsList } = this.state;
        // 防止重复提交
        if (loading) {
            return;
        }
        const { contractAgreedPaymentTerms, customerCompanyId } = params;
        // 兜底：账期配置变更导致原文案匹配不到ID时，不允许把文案当ID提交
        if (contractAgreedPaymentTerms != null && !paymentTermsList.some(el => el.typeConfigureId === contractAgreedPaymentTerms)) {
            message.warning('合同约定账期配置已变更，请重新选择');
            return;
        }
        const { loadData } = this.props;
        this.setState({ loading: true });
        Fetch.post(API_URL.contract.editAgreedPaymentTerms, {
            customerCompanyId,
            contractPaymentTermId: contractAgreedPaymentTerms,
        }).then(res => {
            message.success(res.success);
            this.hide();
            loadData();
        }).catch(err => {
            this.setState({ loading: false });
        });
    }

    handleChange = (value, key) => {
        // 不可变更新，绝不原地修改 state.params
        this.setState(prev => ({
            params: { ...prev.params, [key]: value },
        }));
    }

    render() {
        const  { visible, loading, params, paymentTermsList } = this.state;
        const { customerCompanyCode, customerCompanyName, contractAgreedPaymentTerms } = params;
        const diseaseListOption = paymentTermsList.map(el => <Option key={el.typeConfigureId} value={el.typeConfigureId}>{el.typeValue}</Option>);
        return (
            <Modal
                title="登记合同约定账期"
                visible={visible}
                onOk={this.submit}
                onCancel={this.hide}
                className="create-modal"
                maskClosable={false}
                width="460px"
                confirmLoading={loading}
            >
                <Spin spinning={loading}>
                    <div className="modal-content" style={{ padding: 0 }}>
                        <ul className="modal-list">
                            <li className="modal-item">
                                <div className="item-left" style={{ width: '30%' }}>客户名称:</div>
                                <div className="item-right" style={{ width: '70%' }}>{customerCompanyCode}</div>
                            </li>
                            <li className="modal-item">
                                <div className="item-left" style={{ width: '30%' }}>客户代码:</div>
                                <div className="item-right" style={{ width: '70%' }}>{customerCompanyName}</div>
                            </li>
                            <li className="modal-item">
                                <div className="item-left" style={{ width: '30%' }}>合同约定账期:</div>
                                <div className="item-right" style={{ width: '70%' }}>
                                    <Select
                                        placeholder='请选择'
                                        style={{width: '180px'}}
                                        value={contractAgreedPaymentTerms}
                                        onChange={value => this.handleChange(value, 'contractAgreedPaymentTerms')}
                                    >
                                        {diseaseListOption}
                                    </Select>
                                </div>
                            </li>
                        </ul>
                    </div>
                </Spin>
            </Modal>
        )
    }
    }
export default SigninContract;


// WEBPACK FOOTER //
// ./src/components/contractManagement/responseCustomer/Components/SigninContract.js